import React from 'react';
import ComonTable from '../../../../../common/table/ComonTable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const ActiveVisitors = () => {
    const activeVisitorsData = [
        { visitor: 'Rajesh Patel', vehiclePlate: 'MH12XY5678', assignedSlot: 'P3-PP042', entryTime: '09:30 AM', expectedExit: '01h 45m', status: 'Active' },
        { visitor: 'Amit Shah', vehiclePlate: 'GJ01AB1234', assignedSlot: 'P3-PP011', entryTime: '10:30 AM', expectedExit: '00h 45m', status: 'Active' },
        { visitor: 'Sneha Rao', vehiclePlate: 'KA05AB1234', assignedSlot: 'P2-V018', entryTime: '10:45 AM', expectedExit: '02h 30m', status: 'Active' },
        { visitor: 'Vikram Desai', vehiclePlate: 'MH14CD9012', assignedSlot: 'P2-V019', entryTime: '11:00 AM', expectedExit: '03h 00m', status: 'Active' },
        { visitor: 'Pooja Sharma', vehiclePlate: 'DL01EF3456', assignedSlot: 'P1-V005', entryTime: '11:15 AM', expectedExit: '01h 15m', status: 'Active' },
    ];

    const activeVisitorsColumns = [
        { label: 'VISITOR', key: 'visitor' },
        { label: 'VEHICLE PLATE', key: 'vehiclePlate' },
        { label: 'ASSIGNED SLOT', key: 'assignedSlot' },
        { label: 'ENTRY TIME', key: 'entryTime' },
        { label: 'EXPECTED EXIT', key: 'expectedExit' },
        { label: 'STATUS', key: 'status' }
    ];

    const renderCell = (key, row) => {
        if (key === 'vehiclePlate') {
            return <span className="text-blue-500 font-medium text-[11px]">{row[key]}</span>;
        }
        if (key === 'status') {
            return <span className="px-2 py-0.5 bg-green-100 text-green-700 text-[9px] font-bold rounded-full uppercase tracking-wider">{row[key]}</span>;
        }
        return <span className="text-[11px] text-gray-700 font-semibold">{row[key]}</span>;
    };

    return (
        <div className="mt-2 bg-white border border-bordercolor rounded-xl shadow-sm p-5">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <h3 className="text-xs font-bold text-gray-800">Active Pay & Park Sessions</h3>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
                    <div className="relative w-full sm:w-auto">
                        <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-base">search</span>
                        <input type="text" placeholder="Search units..." className="pl-9 pr-4 py-1.5 border border-gray-200 rounded-lg text-xs w-full sm:w-64 bg-gray-50 focus:bg-white transition-colors outline-none focus:border-blue-300" />
                    </div>
                    <button className="px-3 py-1.5 border border-gray-200 bg-gray-50 hover:bg-gray-100 text-gray-700 text-[11px] font-bold rounded-lg flex items-center justify-center gap-2 transition-colors">
                        <FontAwesomeIcon icon={faDownload} /> Export
                    </button>
                </div>
            </div>
            <ComonTable 
                data={activeVisitorsData} 
                headers={activeVisitorsColumns} 
                renderCell={renderCell}
                pageInfo={{ currentPage: 1, pageSize: 10, totalPages: 1, totalRecords: 128 }}
                onPageChange={() => {}}
                searchQuery=""
            />
        </div>
    );
};

export default ActiveVisitors;
